import { notificationManager } from "@/services/utilities/notification-manager";
import { i18n } from "@/i18n";
import { messageManager } from "@/services/message/message-manager";
import { defineStore } from "pinia";

let latestMessagesRequest = 0;

export const useMessageStore = defineStore({
  id: "Message",
  state: () => {
    return {
      messages: {},
    };
  },

  actions: {
    sendMessage(message) {
      return messageManager.postNewMessage(message).then((success) => {
        if (!success.error) {
          notificationManager.showNotification("success", i18n.global.t("chat.message_success"));
        } else {
          notificationManager.showNotification("error", i18n.global.t("chat.message_error"));
        }
        return success;
      });
    },
    getMessages(archived = 0, trainingCourse = null) {
      const requestId = ++latestMessagesRequest;
      return messageManager.getMessages(archived, trainingCourse).then((messages) => {
        if (requestId === latestMessagesRequest) {
          this.messages = messages;
        }
      });
    },
    setMessageOpen(id) {
      return messageManager.openMessage(id);
    },
    reportMessage(message) {
      return messageManager.reportMessage(message).then(() => {
        // dispatch("refreshMessages", false);
      });
    },
    markThreadReported(threadId, messageId) {
      const thread = this.messages.find((message) => message.id === threadId);
      if (!thread) {
        return;
      }
      thread.hasReportedMessage = true;
      const target = thread.id === messageId ? thread : thread.messages?.find((message) => message.id === messageId);
      if (target) {
        target.isReported = true;
      }
    },
    init() {
      this.messages = {};
    },
  },
});
